export default {
  axios: {
    url: 'https://beta.booksprout.co/api/'
  },
  apolloClient: {
    url: 'https://beta.booksprout.co/api/graphql'
  },
  quadernoApiKey: 'pk_test_zVtjVCesmXZo--pT31C-',
  stripeApiKey: 'pk_test_em1d5DZ5uSDda8RnUhRWjcAg'
}
